// types API use

// API request bodies
export type ReportBody = {
  action_taken: ActionTaken[];
  reporterEmailAddress: string;
  email: string;
  report_option: ReportType;
  keep_email?: boolean;
};

export type SecureBeforeYouClickBody = {
  sender_email: string;
  sender_name: string;
  recipient_name: string;
  recipient_email: string;
  received_at: string;
  subject: string;
  body: string;
  /** The whole email, base64. Optional: ZIM previews body without it. */
  mime?: string;
};

export type TestLinksBody = {
  email: string;
};

// API responses
export type Report = {
  Type: ReportResponseType;
  Title: string;
  Description: string;
  Color: string;
  Action: ReportAction;
};

export type SecureBeforeYouClickResponse = {
  data: { url: string };
};

export type TestLinksResponse = {
  url: string;
};

export type ConfigurationResponse = {
  data: {
    v2: boolean;
    'secure-before-you-click': boolean;
    'test-safely': boolean;
    'unzim-outbound-emails'?: boolean;
    'notification-preference'?: string;
    'organisation-id'?: string | null;
  };
};

// enums
export enum ReportResponseType {
  THREAT = 'Threat',
  SAFE = 'Safe',
  ACTUAL_THREAT = 'ActualThreat',
  SIMULATION = 'Simulation',
}

export enum ReportAction {
  NOTHING,
  SPAM,
  DELETE,
}

export enum ActionTaken {
  VISITED_LINK = 'visited_a_link',
  REPLIED_TO_EMAIL = 'replied_to_email',
  DOWNLOADED_FILE = 'downloaded_a_file',
  OPENED_ATTACHMENT = 'opened_an_attachment',
  ENTERED_PASSWORD = 'entered_my_password',
  ENTERED_OTHER_DATA = 'entered_other_data',
  FORWARDED_EMAIL = 'forwarded_the_email',
}

export enum ReportType {
  SPAM = 'spam',
  PHISHING = 'phishing',
}
